import { render } from "./LogoPuntaNegra.vue?vue&type=template&id=796a57b5"
import script from "./LogoPuntaNegra.vue?vue&type=script&lang=js"
export * from "./LogoPuntaNegra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__